import React, { useEffect, useState, Fragment } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import moment from "moment";
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    Input
} from "reactstrap";

import TSListPay from "components/Forms/TSListPay.js";
import TSBooking from "components/Forms/TSBooking.js";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

const PHR = (props) => {

    const [Data, SetData] = useState([]);
    const [ClinicVisitKey, SetClinicVisitKey] = useState(0);
    const [state, setState] = useState(0);

    const liff = window.liff;
    liff.init({
        liffId: '1654063801-79NgdqBO'
    })
    .then(() => {

        if (liff.isLoggedIn()) {
            
            liff.getProfile().then(function (profile) {

                authenticationService.login(profile.userId, profile.userId)
                    .then(
                        user => {
                            //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                            //this.props.history.push(from);
                            //window.alert(user)
                        },
                        error => {
                            console.log(error);
                        }
                );

            }).catch(function (error) {
                window.alert('Error getting profile: ' + error);
            });
            
        }
    })
    .catch((err) => {

    });

    const currentUser = authenticationService.currentUserValue;

    useEffect(() => {
        fetch('/api/v1/patient/clinicvisit/' + currentUser.hn, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            .then(
                (result) => {
                    SetData(result.data);
                },
                (error) => {
                    //alert(error);
                }
            );
            
    }, []);

    useEffect(() => {
        fetch('/api/v1/patient/clinicvisit/' + currentUser.hn, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            .then(
                (result) => {
                    console.log(result.data);
                    SetData(result.data);
                },
                (error) => {
                    //alert(error);
                }
            );
            
    }, [ClinicVisitKey]);

    function handleClick(row) {
        SetClinicVisitKey(row);
    }

    const handleClick2 = (index) => {
        const updatedState = Data[index];
    
        if (updatedState.other) {
          delete updatedState.other;
          setState((pre) => {

            return pre + 1;
          });
        } else {
          updatedState.other = {
            description: " " //or data from api
          };
          setState((pre) => {
            return pre + 1;
          });
        }
      };

    return (
        // <Container>
        //     <Row>
        //         <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{textAlign: 'center'}}>
        //             <h3 className="p-3 text-center">React - Display a list of items</h3>
        //             <table className="table table-striped table-bordered">
        //                 <thead>
        //                     <tr>
        //                         <th>วันที่</th>
        //                     </tr>
        //                 </thead>
        //                 <tbody>
        //                 {Data && Data.map(data =>
        //                     <tr key={data.clinicVisitKey} onClick={() => handleClick(data.clinicVisitKey)}> 
        //                         <td>{data.docDT}</td>
        //                     </tr>
        //                     )}
        //                 </tbody>
        //             </table>
        //         </Col>
        //     </Row>
        // </Container>

        <div className="wrapper">
            <div className="section" style={{ padding: 30 }}>
                <Container>
                    <h3 className="title" style={{
                        fontSize: '1.2em', backgroundColor: '#f2f2f2', 
                        textAlign: 'center'
                    }}>Personal Health Record</h3>
            
                 </Container>
            </div>

            {/* {Data && Data.map(data =>
            <Container>
            <Row key={data.clinicVisitKey} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
                <Col md="12" xs="12">
                    {data.docDT}
                </Col>
            </Row>
            </Container>
             )} */}

          {Data.map((row, index) => (
            <Fragment key={`${index}${row.ClinicVisitKey}`}>
            <Container>
            <Row key={row.ClinicVisitKey} style={ row.other ? { fontSize: '1em', padding: '10px 10px',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold', backgroundColor: '#f2f2f2'} 
                    : { fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd',
                    cursor: "pointer", textAlign: "center", fontWeight: 'bold'}} onClick={() => handleClick2(index)}>
                 <Col md="6" xs="12">
                    {moment(row.RecordDT).format('D MMM YY, HH:mm น.')}
                </Col>
                <Col md="6" xs="12">
                    {row.ServiceUnit}
                </Col>
            </Row>
            </Container>
              {row.other ? (
                <Container>
                <Row style={{fontSize: '1em', fontWeight: 'bold', textAlign: "center", paddingTop: "20px"}}>
                    <Col md="4" xs="12">
                        {row.Cid}
                    </Col>
                    <Col md="4" xs="12">
                       
                    </Col>
                    <Col md="4" xs="12">
                        {row.Patient}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', fontWeight: 'bold', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        {row.Gender}
                    </Col>
                    <Col md="4" xs="12">
                        {row.Age}
                    </Col>
                    <Col md="4" xs="12">
                        {row.HN}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "center"}}>
                    <Col md="4" xs="12">
                        วันที่ {moment(row.RecordDT).format('D MMM YY, HH:mm น.')}
                    </Col>
                    <Col md="4" xs="12">
                        {row.ServiceUnit}
                    </Col>
                    <Col md="4" xs="12">
                        {row.MC}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.VS}
                    </Col>
                </Row>
                 <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col md="6" xs="12">
                        น้ำหนัก {row.Weight}  กก. ส่วนสูง {row.Height}  ซม. รอบเอว {row.WaistLength} ซม. BMI {row.Bmi} {row.BmiText}
                    </Col>
                    <Col md="6" xs="12">
                        
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PI}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.PE}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.DX}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Lab}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Discharge}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.History}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.Appoint}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", paddingTop: "20px"}}>
                    <Col>
                        {row.NursingCare}
                    </Col>
                </Row>
                <Row style={{fontSize: '1em', textAlign: "left", borderBottom: '1px solid #dddddd', paddingTop: "20px"}}>
                    <Col>
                        {row.Med}
                    </Col>
                </Row>
                </Container>
              ) : null}
            </Fragment>
          ))}
        <DefaultFooter />
        </div>
    );
}

export default PHR;
